import { React, useState, useId, useEffect } from 'react'
import { Box, Button, Divider, TextField, IconButton, Modal, Snackbar } from '@mui/material'
import FileDragUpload from '../../../Utilities/FileUploadAttachDocs'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import FileUploadSharpIcon from '@mui/icons-material/FileUploadSharp';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { styled } from '@mui/material/styles';
import { useCardDetailContext } from '../../../CardDetailContext';
// import {ReactComponent as PdfDefault} from "../../../../Assets/img/icons/PDF default.svg"
import { ToastContainer, toast } from "react-toastify";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import "react-toastify/dist/ReactToastify.css";
import UploadedFile from './UploadedFile';
import UrlUploader from '../../../Utilities/UrlUploader';
import { useQuantityContext } from '../../../QuantityContext';
import useApi from '../../../Utilities/useAPI';
import { ACCEPT } from '../../../../config/constant';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { postAttachDocsReducer } from '../../../../Redux/Reducers/CardReducer';
import axios from 'axios';

const AttachDoc = ({ handleSuccess, handleFailure }) => {

  const { AttachDocs, updateAttachDocs, removeAttachDoc } = useCardDetailContext();
  console.log("AttachDocs", AttachDocs);
  const [openModal, setOpenModal] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const { setisNavigationBlocked } = useQuantityContext();
  const { callApiFunction, loading, error } = useApi();
  const id = AttachDocs?.card_name;
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
  };

  const [Loading, setLoading] = useState(false);
  const { handleInfo } = useQuantityContext();

  const [SaveEnable, setSaveEnable] = useState(false);
  const [initialAttachDocs, setInitialAttachDocs] = useState({});

  const dispatch = useDispatch();
  useEffect(() => {
    setInitialAttachDocs(AttachDocs);
  }, []);

  useEffect(() => {
    setSaveEnable(JSON.stringify(initialAttachDocs) !== JSON.stringify(AttachDocs));
    setisNavigationBlocked(JSON.stringify(initialAttachDocs) !== JSON.stringify(AttachDocs));
  }, [AttachDocs, initialAttachDocs]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({ title: '', body: '' });


  const anyDocsUploaded = AttachDocs.images.length === 0 && AttachDocs.videos.length === 0 && AttachDocs.others.length === 0;

  const inputId = useId();

  const handleAttachIconClick = () => {
    setOpenModal(true);
  }

  const handleFileUrlChange = (event) => {
    setFileUrl(event.target.value);
  }

  const handleModalClose = () => {
    setOpenModal(false);
    setFileUrl('');
  }

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSave = async (event) => {
    event.preventDefault();

    if (!AttachDocs.card_name || AttachDocs?.card_name === "") {
      handleInfo("CardName should not be Empty, Fill it in Personal Details");
      return;
    }

    // const modifiedPayload = {
    //   ...AttachDocs,
    //   images: AttachDocs.images.map((attachment) => ({
    //     document_name: attachment.name,           // Corresponds to document_name
    //     size: attachment.size,                    // Corresponds to size
    //     date: attachment.date,                    // Corresponds to date
    //     document_type: attachment.type,           // Corresponds to document_type
    //     public_url: attachment.data,              // Corresponds to public_url
    //     file_cat: attachment.fileCat,             // Corresponds to file_cat
    //     file_id: attachment.fileId,               // Corresponds to file_id
    //     showQR: attachment.showQR,                // Corresponds to showQR
    //     is_visible: attachment.visible,           // Corresponds to is_visible
    //     is_verified: false,                       // Default value
    //     is_public: false                          // Default value
    //   })),
    //   videos: AttachDocs.videos.map((attachment) => ({
    //     document_name: attachment.name,
    //     size: attachment.size,
    //     date: attachment.date,
    //     document_type: attachment.type,
    //     public_url: attachment.data,
    //     file_cat: attachment.fileCat,
    //     file_id: attachment.fileId,
    //     showQR: attachment.showQR,
    //     is_visible: attachment.visible,
    //     is_verified: false,
    //     is_public: false
    //   })),
    //   others: AttachDocs.others.map((attachment) => ({
    //     document_name: attachment.name,
    //     size: attachment.size,
    //     date: attachment.date,
    //     document_type: attachment.type,
    //     public_url: attachment.data,
    //     file_cat: attachment.fileCat,
    //     file_id: attachment.fileId,
    //     showQR: attachment.showQR,
    //     is_visible: attachment.visible,
    //     is_verified: false,
    //     is_public: false
    //   })),
    // };
    // console.log("modified Payload", modifiedPayload);

    const formData = new FormData();
    if (AttachDocs?.card_id) {
      formData.append('card_id', AttachDocs?.card_id ?? "");
    }
    formData.append('card_name', AttachDocs?.card_name);


    if (AttachDocs?.images) {
      setLoading(true);
      handleInfo("Please wait to complete the process");
      for (const attachment of AttachDocs.images) {
        try {
          const response = await fetch(attachment.data);  // Fetch blob
          const blob = await response.blob();             // Convert to blob
          const file = new File([blob], attachment.name, { type: attachment.type }); // Create File object

          formData.append("images", file);  // Append as binary file

        } catch (error) {
          console.error("Error converting blob to file:", error);
        }
      }
      setLoading(false);
    }


    if (AttachDocs?.videos) {
      setLoading(true);
      handleInfo("Please wait to complete the process");
      for (const attachment of AttachDocs.videos) {
        try {
          const response = await fetch(attachment.data);
          const blob = await response.blob();
          const file = new File([blob], attachment.name, { type: attachment.type });

          formData.append("videos", blob, attachment.name);
        } catch (error) {
          console.error("Error converting video blob to file:", error);
        }
      }
      setLoading(false);
    }

    // if (AttachDocs?.others) {
    //   setLoading(true);
    //   handleInfo("Please wait to complete the process");

    //   for (let i = 0; i < AttachDocs?.others?.length; i++) {
    //     try {
    //       const attachment = AttachDocs.others[i];
    //       const fileType = attachment.type;
    //       console.log("FILE URL in the Attach Documents", fileType);

    //       if (attachment[i]?.data?.startsWith('http') || attachment[i]?.data?.startsWith("https")) {
    //         const websiteLinks = {
    //           "document_name": attachment[i]?.name,
    //           "document_link": attachment[i]?.data,
    //           "document_type": "url",
    //           "document_meta": {
    //             "document_size": attachment[i]?.size || 0
    //           },
    //         };

    //         formData.append("website_links", JSON.stringify(websiteLinks));
    //       } else {
    //         // Fetch and append file attachments
    //         const response = await fetch(attachment.data);
    //         const blob = await response.blob();
    //         formData.append("others", blob, attachment.name);
    //       }

    //       // const response = await fetch(attachment.data);
    //       // const blob = await response.blob();
    //       // const file = new File([blob], attachment.name, { type: attachment.type });

    //       // formData.append("others", blob, attachment.name);

    //     } catch (error) {
    //       console.error("Error converting other blob to file:", error);
    //     }
    //   }
    //   setLoading(false);
    // }

    if (AttachDocs?.others?.length > 0) {
      setLoading(true);
      handleInfo("Please wait to complete the process.");

      for (let i = 0; i < AttachDocs?.others?.length; i++) {
        try {
          const attachment = AttachDocs.others[i];
          const fileName = attachment.name || "Unnamed File"; // Default name
          const fileType = attachment.type;
          const documentLink = attachment.data;
          const fileSize = attachment.size || 0;

          if ((fileType === "application/octet-stream" || fileType === "url") && documentLink.startsWith("http")) {
            // Handle website links
            const websiteLinks = {
              "document_name": fileName,
              "size": "Unknown",
              // "date": "2/14/2025",
              "document_type": "url",
              "public_url": documentLink,
              "file_cat": "others",
              // "file_id": "b9164042-ff8c-4380-982d-7a052dee0f3a",
              "showQR": false,
              "is_visible": true,
              "is_verified": false,
              "is_public": false
            }


            formData.append("website_links", JSON.stringify(websiteLinks));
          } else {
            // Fetch and append file attachments
            const response = await fetch(documentLink);
            const blob = await response.blob();
            formData.append("others", blob, fileName);
          }

        } catch (error) {
          console.error("Error fetching attachment:", error);
        }
      }
      setLoading(false);
    }


    try {

      const response = await dispatch(postAttachDocsReducer(formData))
      // const response = await callApiFunction('uploadDocument', modifiedPayload);

      console.log('Response from backend:', response);
      if (response?.payload?.statusCode === 201) {
        setInitialAttachDocs(AttachDocs);
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/card_document/${id}`,
          { headers: headers }
        );
        handleSuccess();
      } else {
        handleFailure();
      }



    } catch (error) {
      console.error('Error submitting card details:', error);
      handleFailure();
    }
  };

  return (
    <div>
      {/* <Box className='my-4 card-info-box' sx={{ border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, paddingTop: "16px" }}> */}
      <div className="px-3">
        <div className="card-edit-info-heading" style={{ position: "relative" }}>
          <h5>Attach Documents</h5>
          <span>Add Videos, PDFs, and Images</span>
          {anyDocsUploaded === false ? (<span className='span-center-align file-attach-icon-container' onClick={handleAttachIconClick}><IconButton color="inherit">
            <AddCircleRoundedIcon />
          </IconButton>{" "}Attach</span>) : (<></>)}
        </div>

        <div className="my-4">
          {anyDocsUploaded ? (
            <FileDragUpload maxSize={5} accept={ACCEPT} inputId={`file-upload-${inputId}`} contextUpdate={updateAttachDocs} />
          ) : (
            <>
              {AttachDocs?.others?.length > 0 && (
                <>
                  <h5>Files</h5>
                  {AttachDocs?.others?.map((file, index) => (
                    <div className='mb-3'>
                      <UploadedFile file={file} key={index} onDelete={removeAttachDoc} />
                    </div>
                  ))}
                </>
              )}

              {AttachDocs?.videos?.length > 0 && (
                <>
                  <h5>Video</h5>
                  {AttachDocs.videos.map((file, index) => (
                    <div className='mb-3'>
                      <UploadedFile file={file} key={index} onDelete={removeAttachDoc} />
                    </div>
                  ))}
                </>
              )}

              {AttachDocs?.images?.length > 0 && (
                <>
                  <h5>Images</h5>
                  {AttachDocs.images.map((file, index) => (
                    <div className='mb-3'>
                      <UploadedFile file={file} key={index} onDelete={removeAttachDoc} />
                    </div>
                  ))}
                </>
              )}
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                message={
                  <div>
                    <strong>{snackbarMessage.title}</strong>
                    <div>{snackbarMessage.body}</div>
                  </div>
                }
                action={
                  <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                }
                anchorOrigin={{
                  vertical: 'top',    // Position at the top
                  horizontal: 'right', // Position at the right
                }}

              />
            </>
          )}
        </div>

      </div>
      <div className="save-bottom-container">
        <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleSave} disabled={!SaveEnable}>
          Save
        </Button>
      </div>
      <ToastContainer toastClassName="email-toast-success" />
      {/* </Box> */}

      <Modal open={openModal} onClose={handleModalClose}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'background.paper', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, padding: 3 }}>
          <div className="modal-heading">
            <h5>Add Files</h5>
            <span>Attach Documents, Videos, and Images</span>
            <span className='span-center-align file-attach-icon-container'>
              <IconButton color="rgb(0, 0, 0, 0.54)" onClick={handleModalClose}>
                <CloseRoundedIcon />
              </IconButton></span>
          </div>
          <Box className='mt-4' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: "relative" }}>
            <div style={{ flex: "1 1 40%" }}>
              <FileDragUpload setOpenModal={setOpenModal} accept={ACCEPT} maxSize={5} inputId={inputId} uploadIcon={FileUploadSharpIcon} iconSize={32} maxSizeWarning={false} contextUpdate={updateAttachDocs} />
            </div>
            <Divider orientation="vertical" flexItem>
              Or
            </Divider>
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 60%' }}>
              {/* <TextField
                label="Paste URL"
                variant="outlined"
                value={fileUrl}
                onChange={handleFileUrlChange}
                fullWidth
                sx={{marginBottom: "48px"}}
              />
              <div className='d-flex align-items-center justify-content-end' style={{position: "absolute", bottom: "0px", right: "0px"}}>
                      <Button className="secondary-btn" > Cancel </Button>
                      <Button variant="contained" className="primary-btn ms-3" onClick={() => handleModalClose()} sx={{ boxShadow: "none" }} disabled={fileUrl.trim().length === 0}> Add </Button>
              </div> */}
              <UrlUploader file={fileUrl} onChange={handleFileUrlChange} handleModalClose={handleModalClose} contextUpdate={updateAttachDocs} />
            </Box>
          </Box>
        </Box>
      </Modal>

    </div>
  )
}

export default AttachDoc
